enum ToimintaAika {
    Aina = "24/7",
    VirkaAika = "Virka-aika",
    Arkipaiva = "Arkipäivä 24/7",
}

export default ToimintaAika
